// extracted by mini-css-extract-plugin
module.exports = {"sub_header":"_2XRPfbZ"};